module.exports = __webpack_public_path__ + "media/components/src/assets/images/menu_6-db9c66be37b584278d0d27ebce39fd11.jpg";